import React from "react";
import CodeEditor from "../../../../../helpers/CodeEditor2";
import { updateElement, updateCanvasConfig } from "../../../../../stateManager/store/formCreation_v2/actions";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../stateManager/store";
import { setStepIndex } from "../../../../../stateManager/store/onboarding/action";
import TarsLayout from "../../../Assisted/forms/create/properties/TarsLayout";

interface IProps {
  close: () => void;
  editorContext: {
    visibility: boolean
    source: string
    where: string
  }
  isCheckedIn: boolean;
  customdef?: any
  type?: any
  ConditionsChanges?: any,
  setValue?: any
}

export const EditorPanel: React.FC<IProps> = ({ isCheckedIn, close, editorContext, customdef, setValue, type, ConditionsChanges }) => {
  const { source, where, } = editorContext;
  const dispatch = useDispatch();
  const { guideVisible, info } = useSelector((state: AppState) => state.onboarding)
 
  return (
    <TarsLayout
      setTarsModal={close}
      type={type === 'timeline' ? 'inline' : type}
      onOk={() => {
        let event = new KeyboardEvent("keydown", {
          key: "s",
          code: "KeyS",
          ctrlKey: true,
        });
        document.dispatchEvent(event);
        if (guideVisible) {
          dispatch(setStepIndex(info.stepIndex + 1));
        }
      }}
      classNames = {{
        header: {
          save: "tour_panel_function_save"
        }
      }}
      editorRef={customdef} title="CODE EDITOR" modalVisibile={true} canEdit={isCheckedIn} setModalVisible={close}>
      <Editor customdef={customdef} isCheckedIn={isCheckedIn} editorContext={editorContext} source={source} where={where} close={close} setValue={setValue} type={type} ConditionsChanges={ConditionsChanges} />
    </TarsLayout>
  );
};

interface IEditor {
  source: string
  where: string
  isCheckedIn?: boolean
  customdef?: string
  close: () => void;
  type?: any,
  setValue?: any,
  editorContext?: any
  ConditionsChanges?: any
}

// TODO: fetch function typedefs
const Editor: React.FC<IEditor> = ({ isCheckedIn, source, where, customdef, close, type, setValue, ConditionsChanges, editorContext }) => {
  const dispatch = useDispatch()
  const { selectedElementId, components } = useSelector((state: AppState) => state.formJson)
  return (
    <CodeEditor
      readOnly={!isCheckedIn}
      value={source}
      lang="javascript"
      onSave={(
        value: { source: string; comSource: string },
      ) => {
        const whereSplit = where.split('.')
        if (whereSplit[0] === 'canvas') {
          const config: any = {}
          config[whereSplit[1]] = value.source
          dispatch(updateCanvasConfig(config))
        } else if (whereSplit[1] === 'segments') {
          let segmentData = components[selectedElementId].properties.config.segments

          let temp = segmentData.map((item: any) => {
            if (item.key === whereSplit[0]) {
              return { ...item, [whereSplit[2]]: value.source }
            } else {
              return { ...item }
            }
          })
          dispatch(updateElement({
            id: selectedElementId,
            path: "properties.config.segments",
            value: temp,
          }))
        } else if (whereSplit[1] === 'tab') {
          dispatch(
            updateElement({
              id: whereSplit[0],
              path: `${whereSplit[2]}`,
              value: value.source,
            })
          );

        } else if (type === "timeline") {
          if (editorContext?.type === "edit") {
            ConditionsChanges && ConditionsChanges({ type: "onClick", value: value.source, idx: editorContext?.id })
          } else {
            setValue((prevState: any) => ({
              ...prevState,
              onclick: value.source
            }))
          }
        } else {
          dispatch(updateElement({
            id: selectedElementId,
            path: where,
            value: value.source,
          }))
        }
        close()
      }}
      height="100%"
      isLangSelVisible={false}
      type="inline"
      saveMessage={{
        enable: true,
        message: "Click handler added",
      }}
      customdef={customdef}
      additionalOptions={{
        overviewRulerLanes: 0,
        overviewRulerBorder: false,
      }}
    />
  );
};
